import React from "react";
import { SideBarItem } from "./SideBar";
import TableSchema from "../controllers/TableSchema";
import { type Column } from "../controllers/TableSchema";
import { type ActionDropDown } from "../controllers/TableSchema";
import { Table, Button, Layout, Dropdown, Menu, Icon, MenuItem, message } from "antd";
import { type PaginationProps } from "antd/lib/pagination";
import { Select } from "antd";
import TableFilter from "./TableFilter";
import EditableCell from "./EditableCell";
import EditTableRow from "./EditTableRow";
import "./JobTable.css";
import Axios from "axios";
import { TableApi } from "../controllers/TableSchema";
import { AxiosResponse, AxiosError } from "axios";
import InsertTableRow from "./InsertTableRow";
import ConfirmationPopUp from "./ConfirmationPopUp";
import { Message } from "./Messages";

type AiJobsProps = {
  item: SideBarItem,
};

type State = {
  previousItem: ?SideBarItem,
  columns: Column[],
  data: Object[],
  pagination: PaginationProps,
  filterValues?: Object,
  editable: boolean,
  showEditPopUp: boolean,
  fetchData: boolean,
  actionData: ActionDropDown[],
  insertItem: boolean,
  confirmationPopUp: boolean,
  actionKey: string,
  insertRow: boolean,
  selectedRowsData: [],
  selectedRowKeys: string[],
};
export default class JobTable extends React.Component<AiJobsProps, State> {
  tableSchema: TableSchema;
  actionKey: string;
  actionFunction: (key: string) => void;
  // eslint-disable-next-line no-useless-constructor
  constructor(props: AiJobsProps) {
    super(props);
    this.actionKey = null;
    this.actionFunction = null;
    let pageSize = new URLSearchParams(window.location.search).get("page_size");
    try {
      pageSize = parseInt(pageSize);
      if (isNaN(pageSize)) {
        pageSize = 0;
      }
    } catch (e) {
      pageSize = 0;
    }
    pageSize = pageSize && pageSize > 0 && !isNaN(pageSize) ? pageSize : 200;
    this.state = {
      previousItem: null,
      insertRow: false,
      columns: [],
      actionData: [],
      data: [],
      pagination: {
        pageSize: pageSize,
        current: 1,
        position: "bottom",
        onChange: this.cancelEditing,
      },
      editable: false,
      selectedRowsData: [],
      showEditPopUp: false,
      filterValues: null,
      autoRefreshTimeInterval: 60000,
      fetchData: true,
      confirmationPopUp: false,
      // actionKey: null,
      selectedRowKeys: [],
    };
  }

  static getDerivedStateFromProps(props: AiJobsProps, state: State) {
    // Store prevId in state so we can compare when props change.
    // Clear out previously-loaded data (so we don't render stale stuff).
    if (props.item !== state.previousItem) {
      return {
        columns: [],
        fetchData: true,
        insertRow: false,
        selectedRowsData: [],
        filterValues: null,
        previousItem: props.item,
        selectedRowKeys: [],
      };
    }
    // No state update necessary
    return null;
  }

  componentDidUpdate(prevProps: AiJobsProps, prevState: State) {
    if (this.state.fetchData) {
      this.getTableSchema();
    }
  }

  cancelEditing = () => {};

  onSchema = (tableSchema: TableSchema) => {
    this.setState({ fetchData: false });
    if (tableSchema.isError()) {
      //Todo: Handle Error
    } else {
      this.setState({ columns: tableSchema.getColumns(), editable: tableSchema.isTableEditable() }, () => {
        this.fetchData();
        this.getActionData();
      });
    }
  };

  fetchData = () => {
    this.tableSchema
      .fetchData(this.state.pagination, this.state.filterValues)
      .then(this.onTableData)
      .catch(this.onTableData);
  };

  onTableData = (tableSchema: TableSchema) => {
    this.setState({
      data: tableSchema.getTableDataEntries(),
      pagination: { ...this.state.pagination, total: tableSchema.getTotal() },
    });
  };

  componentDidMount() {
    this.getTableSchema();
  }

  getTableSchema() {
    if (this.props.item) {
      this.tableSchema = new TableSchema(this.props.item.getKey());
      this.tableSchema
        .run()
        .then(this.onSchema)
        .catch(this.onSchema);
    }
  }

  onActionsDropDown = (tableSchema: tableSchema) => {
    if (tableSchema.isError()) {
      // Todo:  handle error
    } else {
      this.setState({
        actionData: tableSchema.getActionDropDown(),
      });
    }
  };

  getActionData() {
    this.tableSchema
      .fetchActionData()
      .then(this.onActionsDropDown)
      .catch(this.onActionsDropDown);
  }

  handleTableChange = (pagination: PaginationProps, filters: any, sorter: any) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this.tableSchema
      .fetchData(pager, this.state.filterValues)
      .then(this.onTableData)
      .catch(this.onTableData);
  };

  updateFilterValuesAndFetchData(filterValues: Object) {
    this.setState({ filterValues: filterValues }, () => this.fetchData());
  }

  getFooter(currentPageData: Array<Object>) {
    return <Footer itemsCount={currentPageData.length} pagination={this.state.pagination} />;
  }

  onRowSelection = (keys: string[]) => {
    this.setState({
      selectedRowKeys: keys,
    });
    if (keys === null || keys.length === 0) {
      this.clearRowSelection();
    } else {
      let multipleVal = [];
      try {
        this.state.data.forEach((r) => {
          for (let i = 0; i < keys.length; i++) {
            if (keys[i].toString().indexOf(r.key.toString()) === 0){
            multipleVal.push(r);
            }
          }
        });
        this.setState({
          selectedRowsData: multipleVal,
        });
      } catch (error) {
      }
    }
  };

  editCurrentRecord = () => {
    this.setState({ showEditPopUp: true });
  };

  onEditTableRowClose = () => {
    this.setState(
      {
        showEditPopUp: false,
      },
      () => {
        this.fetchAllData();
      }
    );
  };

  onInsertTableClose = () => {
    this.setState({
      insertRow: false,
    });
  };

  createActionMenuItems(data: Object) {
    return (
      <Menu.Item key={data.key} className="menu-item">
        {data.label}
      </Menu.Item>
    );
  }

  clearRowSelection = () => {
    this.setState({
      selectedRowKeys: [],
      selectedRowsData: [],
    });
  };

  createActionMenu = () => {
    let data = this.state.actionData;
    let menuItems = [];
    data.forEach((item) => {
      menuItems.push(this.createActionMenuItems(item));
    });
    return (
      <Menu onClick={this.onAction} className="menu">
        {menuItems}
      </Menu>
    );
  };

  //*******************************action validation methods****************************//

  onRestartValidation(key: string, actionFunction: (key: string) => void) {
    if (this.state.selectedRowsData.length) {
      this.setActionKeyAndFunction(key, actionFunction);
    } else {
      message.warn(Message.AT_LEAST_SELECT_SINGLE_RECORD);
    }
  }

  onDeleteValidation(key: string, actionFunction: (key: string) => void) {
    if (this.state.selectedRowsData.length === 0) {
      message.warn(Message.AT_LEAST_SELECT_SINGLE_RECORD);
    } else {
      this.setActionKeyAndFunction(key, actionFunction);
    }
  }

  onDeleteAllValidation(key: string, actionFunction: (key: string) => void) {
    this.setActionKeyAndFunction(key, actionFunction);
  }

  onInsertValidation(key: string, actionFunction: (key: string) => void) {
    this.setActionKeyAndFunction(key, actionFunction);
  }

  onRestart7DaysFailedJobValidation(key: string, actionFunction: (key: string) => void) {
    this.setActionKeyAndFunction(key, actionFunction);
  }

  onRestartAllFailedJobValidation(key: string, actionFunction: (key: string) => void) {
    this.setActionKeyAndFunction(key, actionFunction);
  }

  //******************************Action perform methods**************************************//

  onInsert(key: string) {
    this.setState({
      insertRow: true,
    });
  }

  onDeleteAll(key: string) {
    //  this.sendActionData(value, key)
  }

  onRestart(key: string) {
    if (this.state.selectedRowsData.length === 1) {
      this.sendActionData(this.state.selectedRowsData[0], key);
    } else {
      this.sendActionData(this.state.selectedRowsData, key);
    }
  }

  onDelete(key: string) {
    if (this.state.selectedRowsData.length === 1) {
      this.sendActionData(this.state.selectedRowsData[0], key);
    } else {
      this.sendActionData(this.state.selectedRowsData, key);
    }
  }

  onRestart7DaysFailedJob(key: string, actionFunction){
    this.sendActionData({}, key);
  }


  onRestartAllFailedJob(key: string, actionFunction){
    this.sendActionData({}, key);
  }
  //**************************************action confirmation methods*****************************//

  isConfirmationRequired(key: string): boolean {
    for (let i = 0; i < this.state.actionData.length; i++) {
      if (this.state.actionData[i].key === key) if (this.state.actionData[i].confirm) return true;
    }
    return false;
  }

  setConfirmationPopUp = (action: string) => {
    this.setState({
      confirmationPopUp: true,
    });
  };

  unsetConfirmationPopUp = () => {
    this.setState({
      confirmationPopUp: false,
    });
  };

  isActionConfirmed = (confirm: boolean) => {
    if (confirm) {
      this.actionFunction(this.actionKey);
    } else {
      // action not perform
    }
  };

  checkConfirmation = (key: string) => {
    if (this.isConfirmationRequired(key)) {
      // confirmation required
      this.setConfirmationPopUp(key);
    } else {
      // not required
      this.actionFunction(this.actionKey);
    }
  };

  setActionKeyAndFunction = (key: string, actionFunction: (key: string) => void) => {
    this.actionKey = key;
    this.actionFunction = actionFunction;
    this.checkConfirmation(key);
  };

  /************************************on action perform*****************************/

  onAction = (data: Object) => {
    const key = data.key;
    switch (key) {
      case "delete":
        this.onDeleteValidation(key, this.onDelete);
        break;

      case "delete_all":
        this.onDeleteAllValidation(key, this.onDeleteAll);
        break;

      case "restart":
        this.onRestartValidation(key, this.onRestart);
        break;

      case "insert":
        this.onInsertValidation(key, this.onInsert);
        break;
      
      case "restart-last-7-days-failed-job":
        this.onRestart7DaysFailedJobValidation(key,this.onRestart7DaysFailedJob);
        break;

      case "restart-all-failed-jobs":
        this.onRestartAllFailedJobValidation(key,this.onRestartAllFailedJob);
        break;

      default:
        this.sendActionData({}, key);
        break;
    }
  };

  sendActionData = (value: Object, key: string) => {
    Axios({
      method: "post",
      withCredentials: false,
      headers: { "Access-Control-Allow-Origin": "localhost" },
      url: TableApi.POST_ACTION + this.tableSchema.getTableKey() + "/" + key,
      data: value,
    })
      .then((res) => {
        if (res.data.success) {
          message.success(key[0].toUpperCase() + key.slice(1) + " " + Message.SUCCESSFULLY);
          this.fetchAllData();
        } else {
          // Todo: handle Action failed
        }
      })
      .catch((error) => {
        //Todo: handle error
      });
  };

  fetchAllData = () => {
    this.setState(
      {
        // filterValues: undefined,
      },
      () => {
        this.fetchData();
        this.clearRowSelection();
      }
    );
  };

  render() {
    const expandedRowRender = (record) => <p>{record.summary}</p>;
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onRowSelection,
    };
    return (
      <div>
        <div>
          {
            this.props.item.getKey() === "internal-db" ? null :
              <TableFilter
                pagination={this.state.pagination}
                id={this.props.item.getKey()}
                onSubmit={(filterValues) => this.updateFilterValuesAndFetchData(filterValues)}
              // onRefresh={click => this.refresh = click}
              />
          }

          <div className="refresh-edit-div">
            <Dropdown overlay={this.createActionMenu} placement="bottomLeft" trigger={["click"]} className="drop-down">
              <Button type="primary" icon="setting" className="action-btn">
                Action
                <Icon type="down" />
              </Button>
            </Dropdown>
            <Button
              icon="edit"
              type="primary"
              className="refresh-button"
              disabled={!this.state.editable || !this.state.selectedRowsData[0]}
              onClick={this.editCurrentRecord}
            >
              Edit
            </Button>
            <Button
              icon="reload"
              type="primary"
              className="refresh-button"
              onClick={() => {
                // this.refresh();
                this.fetchData();
              }}
            >
              Refresh
            </Button>
          </div>
        </div>
        <Table
          bordered={true}
          rowSelection={rowSelection}
          expandedRowRender={expandedRowRender}
          columns={this.state.columns}
          dataSource={this.state.data}
          size="small"
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
          showHeader={true}
          footer={(currentPageData) => this.getFooter(currentPageData)}
          scroll={{ x:"100%", y: 540 }}
          className="jobs-table"
        />
        {this.state.showEditPopUp ? (
          <EditTableRow onClose={this.onEditTableRowClose} record={this.state.selectedRowsData[0]} tableSchema={this.tableSchema}></EditTableRow>
        ) : null}
        {this.state.insertRow ? (
          <InsertTableRow
            onClose={this.onInsertTableClose}
            tableSchema={this.tableSchema}
            fetchAllData={this.fetchAllData}
            actionKey={this.actionKey}
          ></InsertTableRow>
        ) : null}
        {this.state.confirmationPopUp ? (
          <ConfirmationPopUp
            unsetConfirmationPopUp={this.unsetConfirmationPopUp}
            isActionConfirmed={this.isActionConfirmed}
            actionName={this.state.actionKey}
          ></ConfirmationPopUp>
        ) : null}
      </div>
    );
  }
}

type FooterProps = {
  pagination: PaginationProps,
  itemsCount: number,
};

function Footer(props: FooterProps) {
  return (
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      <p style={{ marginBottom: 0, width: "100%" }}>
        Items: {props.itemsCount} Page: {props.pagination.current} Total: {props.pagination.total}
      </p>
    </div>
  );
}
